import { Link } from "react-router-dom";
import VaulzoLogo from "./VaulzoLogo";

const links = [
  { href: "#features", label: "Features" },
  { href: "#how", label: "How it works" },
  { href: "#faq", label: "FAQ" },
];

/** Quiet footer: logo, one-line description, section links, copyright. */
export default function LandingFooter() {
  return (
    <footer className="border-t border-vaulzo-hairline">
      <div className="mx-auto flex max-w-[800px] flex-col gap-8 px-6 py-12 sm:flex-row sm:items-start sm:justify-between">
        <div>
          <Link to="/" className="inline-flex">
            <VaulzoLogo />
          </Link>
          <p className="mt-3 max-w-xs text-sm leading-relaxed text-vaulzo-faint">
            A calm dashboard for net worth, allocation, and what you owe — built
            for personal use.
          </p>
        </div>

        <div className="flex flex-col gap-4 sm:items-end">
          <nav className="flex flex-wrap gap-x-6 gap-y-2 text-sm">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                className="text-vaulzo-faint transition-colors hover:text-vaulzo-ink"
              >
                {l.label}
              </a>
            ))}
          </nav>
          <p className="text-sm text-vaulzo-fainter">
            © {new Date().getFullYear()} Vaulzo
          </p>
        </div>
      </div>
    </footer>
  );
}
